<mat-radio-group [(ngModel)]="question.answer!.value" (change)="change()" aria-label="Select an option">
  <mat-radio-button [value]="true" i18n="@@Yes">{{"Yes"| translate}}</mat-radio-button>
  <mat-radio-button [value]="false" i18n="@@No">{{"No" | translate}}</mat-radio-button>
</mat-radio-group>
